import React, { useEffect, useState } from "react";
import useAxios from "../utils/useAxios";
import { hideModal, showModal } from "../utils/modalUtility";
import { useAppContext } from "../context/AppContext";

const TrNumber = () => {
  const [page, setPage] = useState(1);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [role, setRole] = useState(null);
  const { state } = useAppContext();

  const axiosAPI = useAxios();
  const [formData, setFormData] = useState({
    table_name: "",
    start_tr_number: "",
    end_tr_number: "",
  });

  function removeFormData() {
    setFormData({
      table_name: "",
      start_tr_number: "",
      end_tr_number: "",
    });
    setIsEditMode(false);
  }

  const handlePageClick = (pageNum) => {
    if (pageNum >= 1 && pageNum <= totalPages) {
      setPage(pageNum);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  async function fetchData() {
    setLoading(true); // Start loading
    // const queryString = buildQuery();

    try {
      const res = await axiosAPI.get(`/api/tr-number/get-tr-numbers`);
      // console.log("Gifts", res.data);
      setData(res.data?.data);
      setTotalPages(res.data?.totalPages);
    } catch (err) {
      console.error("Error fetching gifts:", err);
    } finally {
      setLoading(false); // Always stop loading
    }
  }

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/tr-number/tr-numbers/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchData();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger",
      );
    }
  };

  const openAddModal = () => {
    // Optionally, you can open the modal programmatically here if you're using Bootstrap modals
    removeFormData();
    showModal("newUserModal");
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      start_tr_number: formData.start_tr_number,
      end_tr_number: formData.end_tr_number,
      table_name: formData.table_name,
    };

    // console.log(payload);

    // return;

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(
          `/api/tr-number/update-tr-number/${currentUserId}`,
          payload,
        );
        window.notifyMessage(
          "Success",
          "TR Number updated successfully",
          "success",
        );
      } else {
        response = await axiosAPI.post("/api/tr-number/add-tr-number", payload);
        window.notifyMessage(
          "Success",
          "TR Number added successfully",
          "success",
        );
      }
      hideModal("newUserModal");
      fetchData();

      setIsEditMode(false);
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);

    // Find the notification with this ID and populate the form
    const selected_tr_number = data.find((donor) => donor.id === id);

    setCurrentUserId(id);

    // console.log(selected_tr_number);

    setFormData({
      table_name: selected_tr_number.table_name,
      start_tr_number: selected_tr_number.start_tr_number,
      end_tr_number: selected_tr_number.end_tr_number,
    });

    showModal("newUserModal");
  };

  useEffect(() => {
    // const role = JSON.parse(localStorage.getItem("user_role")); // Parses string "admin" to plain string
    setRole(state?.user?.role);
    fetchData();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex flex-column flex-md-row justify-content-end align-items-stretch align-items-md-center mb-3 gap-2">
          {/* Right side: Buttons container */}
          <div className="d-flex flex-column flex-sm-row gap-2">
            {/* <button
              type="button"
              className="btn btn-success btn-round"
              // onClick={handleExportDonations}
              onClick={() => {
                if (filters.search || filters.level) {
                  downloadExcel("donor"); // Pass filters if needed
                } else {
                  const confirmFullDownload = window.confirm(
                    "No filters applied. Do you want to download the full sheet?"
                    );
                  if (confirmFullDownload) {
                    downloadExcel("donor"); //  Full sheet export
                  }
                }
              }}
              disabled={downloading}
            >
              Export Donor
            </button> */}
            {/* 
            <button
              type="button"
              className="btn btn-success btn-round"
              onClick={() => openUploadDonorModal()}
            >
              Upload Donor
            </button>
            <button
              type="button"
              className="btn btn-success btn-round"
              onClick={() => handleBulkUpdateModal()}
            >
              Bulk Update
            </button> */}
            <button
              type="button"
              className="btn btn-dark btn-round"
              onClick={() => openAddModal()}
            >
              Add Tr Number
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Tr Number" : "Add Tr Number"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Table Name Dropdown */}
                  <div className="mb-3">
                    <label htmlFor="table_name" className="form-label">
                      Table Name
                    </label>
                    <select
                      className="form-select"
                      id="table_name"
                      name="table_name"
                      value={formData.table_name}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Table</option>
                      <option value="donations">Donations</option>
                      <option value="manual_recurring_donations">
                        Manual Recurring Donations
                      </option>
                      <option value="recurring_donations">
                        Recurring Donation
                      </option>
                      {/* Add more options as needed */}
                    </select>
                  </div>

                  {/* Start TR Number */}
                  <div className="mb-3">
                    <label htmlFor="start_tr_number" className="form-label">
                      Start TR Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="start_tr_number"
                      name="start_tr_number"
                      placeholder="Enter start TR number"
                      value={formData.start_tr_number}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* End TR Number */}
                  <div className="mb-3">
                    <label htmlFor="end_tr_number" className="form-label">
                      End TR Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="end_tr_number"
                      name="end_tr_number"
                      placeholder="Enter end TR number"
                      value={formData.end_tr_number}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode ? "Update Tr NUmber" : "Add Tr Number"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* 
          <h1>Upload History</h1> */}

        {/* History Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-end flex-wrap gap-3">
                {/* Title */}
                {/* <h4 className="card-title mb-0">All Gifts ({gifts.length})</h4> */}
                {/* <h4 className="card-title mb-0">All History ({data.length})</h4> */}
                <h4 className="card-title mb-0">
                  All Tr Number ({data?.length})
                </h4>

                {/* Filter section - horizontal layout */}
                {/* <div className="d-flex align-items-end gap-2 flex-wrap">
                  {role === "admin" && (
                    <div
                      className="position-relative"
                      style={{ width: "310px" }}
                    >
                      <input
                        className="form-control shadow-sm px-3 py-2  border-2 w-100"
                        type="text"
                        placeholder="Enter name or phone_number or donor ID..."
                        value={filters.search}
                        onChange={(e) =>
                          handleFilterChange("search", e.target.value)
                        }
                        style={{ paddingRight: "110px" }}
                      />
                    </div>
                  )}
                  <div className="d-flex flex-column">
                    <label htmlFor="fromDate" className="form-label mb-1">
                      From
                    </label>
                    <input
                      id="fromDate"
                      type="date"
                      className="form-control"
                      value={filters.from_date || ""}
                      onChange={(e) =>
                        handleFilterChange("from_date", e.target.value)
                      }
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <label htmlFor="toDate" className="form-label mb-1">
                      To
                    </label>
                    <input
                      id="toDate"
                      type="date"
                      className="form-control"
                      value={filters.to_date || ""}
                      onChange={(e) =>
                        handleFilterChange("to_date", e.target.value)
                      }
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <button
                      className="btn btn-primary rounded-pill px-4"
                      onClick={() => {
                        if (
                          filters.search ||
                          (filters.from_date && filters.to_date)
                        ) {
                          setPage(1);
                          fetchGifts();
                        } else {
                          alert("Please select both From and To dates.");
                        }
                      }}
                    >
                      Filter
                    </button>
                  </div>
                  <div className="d-flex flex-column">
                    <button
                      className="btn btn-icon btn-round btn-dark py-3 px-3  me-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Reset Filters"
                      onClick={handleResetFilters}
                    >
                      <i className="fas fa-sync-alt"></i>
                    </button>
                  </div>
                </div> */}
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Start Tr Number</th>
                        <th>End Tr Number</th>
                        <th>Current Tr Number</th>
                        <th>Table Name</th>
                        {/* <th>Scheme Patronship No. </th> */}
                        {/* <th>issued Date</th> */}

                        {/* <th>Modified Time</th> */}
                        {/* <th>Created At</th> */}
                        {/* <th>Action</th> */}
                        {role === "admin" && (
                          <th>Action</th> // Show this if the role is "admin"
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : data?.length === 0 ? (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        data?.map((data) => {
                          const formattedDateTime = new Date(
                            data.upload_date,
                          ).toLocaleString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true, // Optional: use 12-hour format like 2:30 PM
                            timeZone: "Asia/Kolkata",
                          });

                          return (
                            <tr key={data.id}>
                              <td>{data.id}</td>
                              <td>{data.start_tr_number}</td>
                              <td>{data.end_tr_number}</td>
                              <td>{data.current_tr_number}</td>
                              <td>{data.table_name}</td>
                              {/* <td>{data.contact_id}</td> */}
                              {/* <td>{data.gift_id}</td> */}

                              {/* <td>{truncatedMessage}</td> */}
                              {/* <td>{formattedDate}</td> */}
                              <td>
                                {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                    onClick={() => openEditModal(data.id)}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                )}
                                {role === "admin" && (
                                  <button
                                    className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                    onClick={() => handleDelete(data.id)}
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <nav aria-label="Page navigation">
              <ul className="pagination flex justify-content-end">
                {/* First Page */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(1)}
                  >
                    First
                  </button>
                </li>

                {/* Previous */}
                <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page - 1)}
                  >
                    Previous
                  </button>
                </li>

                {/* Page Number Buttons in chunks */}
                {(() => {
                  const pageNumbers = [];
                  const maxPagesToShow = 5;
                  const startPage =
                    Math.floor((page - 1) / maxPagesToShow) * maxPagesToShow +
                    1;
                  const endPage = Math.min(
                    startPage + maxPagesToShow - 1,
                    totalPages,
                  );

                  for (let i = startPage; i <= endPage; i++) {
                    pageNumbers.push(
                      <li
                        key={i}
                        className={`page-item ${page === i ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageClick(i)}
                        >
                          {i}
                        </button>
                      </li>,
                    );
                  }
                  return pageNumbers;
                })()}

                {/* Next */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(page + 1)}
                  >
                    Next
                  </button>
                </li>

                {/* Last Page */}
                <li
                  className={`page-item ${
                    page === totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageClick(totalPages)}
                  >
                    Last
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrNumber;
